import {Component, Element, Event, EventEmitter, h, Listen, Prop, State} from "@stencil/core";
import {AccessibilityUtils} from "../../core/utils/AccessibilityUtils";
import {WebUtils} from "../../core/utils/WebUtils";
import {StringUtils} from "../../core/utils/StringUtils";

@Component({
  tag: "snt-link",
  styleUrl: "link-component.scss",
  shadow: false
})
export class LinkComponent {

  public static readonly TAG_NAME = "snt-link";

  @Prop() linkId: string;
  @Prop({reflect: true}) href: string;
  @Prop({reflect: true}) target: string;
  @Prop({reflect: true}) ariaLabel:string;
  @Prop({reflect: true}) current:boolean;
  @Prop({reflect: true}) download:string;
  @Prop({reflect: true}) ariaCurrent:string|boolean;
  @Prop({reflect: true}) rel:string;
  @Prop({reflect: true}) hiddenTitle:string = StringUtils.empty();
  @Prop() isExternal: boolean = false;
  @Prop() classNames: string = StringUtils.empty();
  @Prop() disableFocus: boolean = false;
  @Prop() hasExpander: boolean = false;
  @Prop() forTab:number;
  @Prop() isTopNavLink:boolean = false;

  @State() expanded: boolean = false;

  @Element() element!: HTMLElement;

  @Event() linkEvent: EventEmitter;
  @Event() newLinkEvent: EventEmitter;

  private content;

  @Listen('keydown')
  handleKeyDown(keyboardEvent: KeyboardEvent){
    this.linkEvent.emit(keyboardEvent);
  }

  @Listen('click')
  handleClick(clickEvent: MouseEvent){
    this.linkEvent.emit(clickEvent);
  }

  @Listen('mouseover')
  handleMouseover(clickEvent: MouseEvent){
    this.linkEvent.emit(clickEvent);
  }

  componentWillLoad() {
     this.content = <slot/>;
    const isExternalLink = AccessibilityUtils.isAccessibilityLinkRequired(this.element, this.href, this.target);
    if(isExternalLink) {
      let title = AccessibilityUtils.getNewWindowTitle();
      let text = AccessibilityUtils.getNewWindowText();
      this.content = [<span class="link-content">{this.content}</span>,
        <span class='icon-font icon-new-window' title={title}>
          <span class='sr-only'> {text}</span>
        </span>
      ];
      if(this.rel) {
        if(!this.rel.includes('noopener')) {
          this.rel = this.rel.concat(' noopener ');
        }
      } else {
          this.rel = 'noopener';
      }
    }

    if(this.download) {
      this.content = [
          <span class="link-content">{this.content}</span>,
            <span class='icon-font icon-global-download' title={this.download}>
                <span class='sr-only'>{this.download}</span>
            </span>
      ];
    }
  }

  private toggleExpanded = () => {
    // send a emit here to header to expand
    this.newLinkEvent.emit(this.forTab);
  }

  private handleTopNavClick = (e) => {
    if (this.isTopNavLink) {
      e.preventDefault();
      this.toggleExpanded();
    }
  }

  render() {
    const expander = (
      <button
          type="button"
          class="expander"
          onClick={(e) => e.preventDefault()}
          tabIndex={-1}
      >
          <snt-icon styleClasses={(this.expanded) ? "icon-icon_nav_minus_inv" : "icon-icon_nav_plus"}></snt-icon>
      </button>
    );

    let text = this.content;
    if (this.hasExpander) {
      text = <div class="menu-nav-text">{this.content}</div>
    }
      
    return [
        <a id={this.linkId} rel={this.rel} href={this.href} target={this.target} aria-label={this.ariaLabel} class={WebUtils.generateClasses([],this.classNames)} download={this.download} hidden-title={this.hiddenTitle} tabIndex={this.disableFocus ? -1 : null} onClick={this.isTopNavLink && this.handleTopNavClick}>
          {text}
          {this.hasExpander && <div class="menu-nav-icon">{expander}</div>}
        </a>
    ]
  }
}
